import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CourseService } from '../services/course.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  displayedColumns: string[] = ['action', 'test', 'topic', 'courseID'];
  dataSource = new MatTableDataSource<any>();
  courseAssessment = [];
  courseFilterValues: any = {
    test: '',
    topic: '',
    courseID: ''
  }
  showModal: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectedCourseTopicRow: any;

  constructor(private readonly router: Router, private readonly courseService: CourseService, private readonly http: HttpClient, private readonly toastr: ToastrService) { }

  ngOnInit() {
    this.viewCourse();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilterHome();
  }

  async viewCourse() {
    let pageNumber = 0;
    this.courseService.getCourseMapping(0).subscribe({
      next: async (data: any) => {
        let outputData = data;
        while (data.length != 0) {
          pageNumber = pageNumber + 1;
          try {
            let res = await new Promise<any>(resolve => this.http.get(environment.apiUrl + '/course/mapping/' + pageNumber)
              .subscribe(
                (res: any) => { resolve(res); },
                (error: any) => {

                }
              ));

            if (res.length === 0) {
              break;
            }
            console.log(outputData)
            console.log(res)
            outputData = outputData.concat(res);

          } catch (e: any) {

          }
        }
        console.log(outputData)
        this.courseAssessment = outputData;
        this.dataSource = new MatTableDataSource<any>(this.courseAssessment);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = this.createFilterHome();
        this.fieldListenerHome();
        this.toastr.success('The courses are loaded successfully.', 'Success!');
      },
      error: (error: any) => {
        this.toastr.error('There is some error. Kindly try again later.', 'Error')
      }
    })
  }

  fieldListenerHome() {
    this.dataSource.filter = JSON.stringify(this.courseFilterValues);
  }

  createFilterHome(): (course: any, filter: string) => boolean {
    let filterFunction = function (course: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      return course.test?.toLowerCase().includes(searchTerms.test.toLowerCase())
        && course.topic?.toLowerCase().includes(searchTerms.topic.toLowerCase())
        && course.courseID?.toLowerCase().includes(searchTerms.courseID.toLowerCase())
    }
    return filterFunction;
  }

  reset() {
    this.courseFilterValues = {
      test: '',
      topic: '',
      courseID: ''
    };
    this.dataSource = new MatTableDataSource<any>(this.courseAssessment);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = this.createFilterHome();
    this.fieldListenerHome();
  }

  addNewAssessment() {
    this.router.navigate(['/add-new-assessment']);
  }

  addNewCourse() {
    this.router.navigate(['/add-new-course']);
  }

  editTopicCourse(row: any) {
    this.selectedCourseTopicRow = row;
    this.showModal = true;
  }

  onPopupClosed(evt: boolean) {
    if(evt) {
      this.courseAssessment = [];
        this.dataSource = new MatTableDataSource<any>(this.courseAssessment);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      this.viewCourse();
    } 
    this.showModal = false;
  }
}
